import type { ReactNode } from 'react';

import type { GroupMember } from '../../services/api/types.gen';

function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('');
}

type MemberRowProps = {
  member: GroupMember;
  tag?: string;
  action?: ReactNode;
};

/** One person: initials, name, disciplines, an optional tag and action. */
export function MemberRow({ member, tag, action }: MemberRowProps) {
  return (
    <div className='flex min-w-0 items-center gap-2 py-1'>
      <span
        aria-hidden
        className='flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-muted text-xs font-medium'
      >
        {initials(member.name)}
      </span>
      <div className='flex min-w-0 flex-1 flex-col'>
        <span className='truncate text-sm'>{member.name}</span>
        {(member.disciplines.length > 0 || tag) && (
          <span className='truncate text-xs text-muted-foreground'>
            {member.disciplines.join(', ')}
            {member.disciplines.length > 0 && tag ? ' · ' : ''}
            {tag && <span>{tag}</span>}
          </span>
        )}
      </div>
      {action}
    </div>
  );
}
